module.exports = __webpack_public_path__ + "assets/actions.29b1ebb2.svg";